export default __webpack_public_path__ + "static/media/icon-em-empty.a06b9578.svg";